import { isFeatureEnabled } from 'owa-feature-flags';
import { GUIDED_CAPTURE_FULL_CONTAINER_FEATURE } from '../FeaturesFlagName';

export default function isGuidedCaptureFullContainerFeatureEnabled() {
    return isFeatureEnabled(GUIDED_CAPTURE_FULL_CONTAINER_FEATURE);
}
